import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { NewsletterSignup } from './NewsletterSignup';

const NAV_COLUMNS = [
  {
    title: 'Shop',
    links: [
      { label: 'Books', to: '/books' },
      { label: 'Apparel', to: '/apparel' },
      { label: 'Prints', to: '/studio' },
    ],
  },
  {
    title: 'Studio',
    links: [
      { label: 'About', to: '/about' },
      { label: 'Contact', to: '/contact' },
    ],
  },
];

export const SiteFooter = () => {
  const year = new Date().getFullYear();
  return (
    <footer
      className="bg-cream border-t border-ink/10 mt-32"
      data-testid="site-footer"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-16 py-20">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-12 md:gap-10">
          {/* Brand block */}
          <div className="md:col-span-5">
            <Link to="/" className="inline-block" aria-label="Graves Collective — Home">
              <img
                src="https://customer-assets.emergentagent.com/job_9cdf2342-a607-473f-8553-b1e4a60c73ce/artifacts/6el8ycim_Graves%20Collective%20Logo.png"
                alt="Graves Collective"
                className="h-44 w-auto -ml-6 select-none mix-blend-multiply"
                draggable="false"
              />
            </Link>
            <p className="mt-6 text-soft max-w-sm leading-relaxed">
              The studio shop of Joseph Graves Jr. Original paintings, signed
              prints, illustrated books, and wearable art — made by hand in
              Colorado.
            </p>
            <a
              href="https://josephgravesjr.com"
              target="_blank"
              rel="noopener noreferrer"
              className="group mt-8 inline-flex items-center gap-2 text-xs uppercase tracking-[0.18em] text-ink hover:text-terracotta transition-colors"
              data-testid="footer-artist-site-link"
            >
              <ArrowLeft className="w-3.5 h-3.5 transition-transform group-hover:-translate-x-1" />
              Joseph Graves Jr. — Artist Studio
            </a>

            <div className="mt-10 pt-8 border-t border-ink/10 max-w-sm">
              <NewsletterSignup source="footer" />
            </div>
          </div>

          {/* Nav columns */}
          <div className="md:col-span-4 md:col-start-7 grid grid-cols-2 gap-10">
            {NAV_COLUMNS.map((col) => (
              <div key={col.title}>
                <h4 className="text-xs uppercase tracking-[0.18em] text-ink mb-5">
                  {col.title}
                </h4>
                <ul className="space-y-3">
                  {col.links.map((l) => (
                    <li key={l.to}>
                      <Link
                        to={l.to}
                        className="text-sm text-soft hover:text-terracotta transition-colors"
                      >
                        {l.label}
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          {/* Contact / payment */}
          <div className="md:col-span-3 md:col-start-11">
            <h4 className="text-xs uppercase tracking-[0.18em] text-ink mb-5">
              Studio
            </h4>
            <address
              className="text-sm text-soft leading-relaxed not-italic"
              data-testid="footer-studio-address"
            >
              900 Santa Fe Drive, Studio D
              <br />
              Denver, CO 80204
            </address>
            <p className="mt-3 text-xs text-soft leading-relaxed">
              Open during{' '}
              <a
                href="https://denversantafe.org/first-friday-art-walk"
                target="_blank"
                rel="noopener noreferrer"
                className="text-ink hover:text-terracotta transition-colors underline decoration-ink/20 hover:decoration-terracotta"
              >
                First Friday Art Walks
              </a>{' '}
              · Visits by appointment otherwise.
            </p>
          </div>
        </div>

        <div className="mt-20 pt-8 border-t border-ink/10 flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
          <p className="text-xs text-soft tracking-wide">
            © {year} Joseph Graves Jr. Studio. All works ©.
          </p>
          <p className="text-xs text-soft tracking-wide">
            Graves Collective — a studio shop.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default SiteFooter;
